import clsx from "clsx";
import { Page, usePage } from "@tree-company/tree-query";
import translate from "../locales";
import {
  FormEvent,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from "react";
import { Header } from "./header";
import { LanguageContext } from "../app";
import SupplierBanner from "./supplier_banner";

export function PageComponent({
  className,
  page,
  submitting,
  handleSave,
  onPreviousPage,
  children,
}: {
  className?: string | undefined;
  page: Page;
  submitting: boolean;
  handleSave: (event: FormEvent<Element>) => void;
  onPreviousPage: () => void;
  children: ReactElement[];
}) {
  const language = useContext(LanguageContext);
  const { disablePrevious, htmlAttributes, order } = usePage(page);
  const [disableNext, setDisableNext] = useState(false);

  useEffect(() => {
    setDisableNext(!page.validate({ silent: true }));
  }, []);

  useEffect(() => {
    const id = page.treesponse.subscribe(
      page.settings.sections.map((s) => s.key),
      () => {
        setDisableNext(!page.validate({ silent: true }));
      },
    );

    return () => page.treesponse.unsubscribe(id);
  }, [[page]]);

  return (
    <form
      className={clsx("page", htmlAttributes?.class, className)}
      onSubmit={handleSave}
    >
      <div>
        <Header page={page} />
        <div className="page__main-content">{children}</div>
      </div>

      <div className="page__actions">
        {order > 1 && (
          <button
            className="button page__previous"
            onClick={(e) => {
              e.preventDefault();
              onPreviousPage();
            }}
            disabled={submitting || disablePrevious}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="12"
              viewBox="0 0 9 12"
              fill="none"
            >
              <path
                d="M6.7998 12L0.799805 6L6.7998 0L8.1998 1.4L3.5998 6L8.1998 10.6L6.7998 12Z"
                fill="currentColor"
              />
            </svg>

            {translate("layout.previous", {}, language)}
          </button>
        )}
        <button
          className="button button--accent page__next"
          type="submit"
          aria-disabled={submitting || disableNext}
        >
          {translate("layout.next", {}, language)}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="12"
            viewBox="0 0 9 12"
            fill="none"
          >
            <path
              d="M2.2002 -5.24537e-07L8.2002 6L2.2002 12L0.800195 10.6L5.4002 6L0.800196 1.4L2.2002 -5.24537e-07Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      {page.order === 1 && <SupplierBanner />}
    </form>
  );
}
